import { FiEdit2 } from 'react-icons/fi';
import { FaStar, FaRegStar } from 'react-icons/fa';
import { formatDate } from '../../../../../utlis';
import MyTable from '../../../../../components/MyTable';
import FilterPopup from '../../../../../components/FilterPopup';

// Render star rating
const renderStarRating = (rating) => {
  const maxStars = 5;
  const ratingValue = parseInt(rating, 10) || 0;
  const stars = [];

  for (let i = 1; i <= maxStars; i++) {
    stars.push(
      i <= ratingValue ? (
        <FaStar key={i} className="text-yellow-400" size={14} />
      ) : (
        <FaRegStar key={i} className="text-gray-300" size={14} />
      )
    );
  }

  return <div className="flex gap-0.5">{stars}</div>;
};

const CandidateTrainingsTable = ({
  data,
  onEditTraining,
  pageSize,
  onPageSizeChange,
  isFilterPopupOpen,
  onFilterClick,
  onCloseFilterPopup,
  onApplyFilters,
  getSearchResults,
  filterCategories,
}) => {
  // Transform data to ensure consistent field names
  const transformedData = data.map((trainingItem) => ({
    id: trainingItem.training_id || trainingItem.record_id || trainingItem.id || '',
    class_name: trainingItem.class_name || '',
    status: trainingItem.status || '',
    rating: trainingItem.rating || 0,
    feedback: trainingItem.feedback || '',
    faculty_name: trainingItem.faculty_name || '',
    created: trainingItem.created || '',
  }));

  const columns = [
    {
      name: 'id',
      label: 'ID',
      options: {
        display: false,
      },
    },
    {
      name: 'class_name',
      label: 'Class Name',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta) => {
          const id = tableMeta.rowData[0];
          return (
            <h3
              onClick={() => onEditTraining(id)}
              className="text-base font-bold text-auxiliary-800 cursor-pointer hover:underline"
            >
              {value || 'N/A'}
            </h3>
          );
        },
      },
    },
    {
      name: 'rating',
      label: 'Rating',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => renderStarRating(value),
      },
    },
    {
      name: 'feedback',
      label: 'Feedback',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (
          <p className="text-text-hint truncate max-w-[200px]" title={value || ''}>
            {value || 'N/A'}
          </p>
        ),
      },
    },
    {
      name: 'faculty_name',
      label: 'Faculty Name',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => value || 'N/A',
      },
    },
    {
      name: 'created',
      label: 'Date Created',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (value ? formatDate(value) : 'N/A'),
      },
    },
    {
      name: 'status',
      label: 'Status',
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => (
          <span className="font-bold">{value || 'N/A'}</span>
        ),
      },
    },
    {
      name: 'actions',
      label: 'Actions',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          const recordId = tableMeta.rowData[0];
          return (
            <button
              onClick={() => onEditTraining(recordId)}
              className="p-2 hover:bg-gray-200 rounded-full"
              title="Edit Training"
            >
              <FiEdit2 size={16} className="text-secondary-700" />
            </button>
          );
        },
      },
    },
  ];

  const options = {
    filterType: 'dropdown',
    responsive: 'standard',
    rowsPerPage: pageSize,
    rowsPerPageOptions: [5, 10, 15, 20, 50],
    onChangeRowsPerPage: (numberOfRows) => onPageSizeChange(numberOfRows),
    selectableRows: 'none',
    elevation: 0,
    download: true,
    print: true,
    search: false,
    viewColumns: true,
    filter: true,
  };

  return (
    <div className="w-full overflow-x">
      <MyTable
        title=""
        data={transformedData}
        columns={columns}
        options={options}
        onFilterClick={onFilterClick}
      />
      {isFilterPopupOpen && (
        <FilterPopup
          onClose={onCloseFilterPopup}
          onApply={onApplyFilters}
          tableData={data}
          categories={filterCategories}
          getSearchResults={getSearchResults}
        />
      )}
    </div>
  );
};

export default CandidateTrainingsTable;
